import { render, staticRenderFns } from "./InternationalFooter.vue?vue&type=template&id=306ce163&scoped=true&"
import script from "./InternationalFooter.vue?vue&type=script&lang=js&"
export * from "./InternationalFooter.vue?vue&type=script&lang=js&"
import style0 from "./InternationalFooter.vue?vue&type=style&index=0&id=306ce163&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306ce163",
  null
  
)

export default component.exports